import { render, staticRenderFns } from "./SidebarMenuClient.vue?vue&type=template&id=aa5b5d70&"
import script from "./SidebarMenuClient.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports